<header class="z-20 relative">
  <!-- Banner Top -->
  <section *ngIf="banners?.length > 0" class="hidden sm:block">
    <div class="container-full full_banner mb-4">
      <ng-container *ngFor="let banner of banners;">
        <ng-container *ngIf="banner.core_visual_banner_area == 'full_banner_top_head'">
          <button (click)="banners_fnc_cta(banner)">
            <img loading="lazy" class="d-none d-sm-block hidden sm:block w-full" src="{{banner.url_image}}" alt="{{banner.name}}" />
            <img loading="lazy" class="d-block d-sm-none sm:hidden" src="{{banner.url_image_mobile}}" alt="{{banner.name}}" />
          </button>
        </ng-container>
      </ng-container>
    </div>
  </section>

  <!-- First Section -->
  <section class="hidden mx-auto max-w-7xl sm:block">
    <div class="flex items-center justify-between p-4 sm:p-0 sm:pt-4 sm:px-6">
      <div class="flex items-center space-x-4">
        <a href="https://www.facebook.com/casadege.com.br" target="_blank">
          <img loading="lazy" class="w-6 opacity-40 hover:opacity-20" src="/assets/images/redes_sociais/facebook.webp" alt="Facebook" />
        </a>
        <a href="https://instagram.com/casadege" target="_blank">
          <img loading="lazy" class="w-6 opacity-40 hover:opacity-20" src="/assets/images/redes_sociais/instagram.webp" alt="Instagram" />
        </a>
        <a href="https://youtube.com.br/channel/UC9sKpdku8Hy7t2Cru0vuaMw" target="_blank">
          <img loading="lazy" class="w-6 opacity-40 hover:opacity-20" src="/assets/images/redes_sociais/youtube.webp" alt="Youtube" />
        </a>
      </div>
      <div class="flex items-center space-x-8 text-gray-700">
        <div>
          <a href="https://wa.me/+5511966294417" class="flex items-center space-x-2" target="_blank">
            <img loading="lazy" src="/assets/images/whatsapp.webp" alt="WhatsApp" class="hover:opacity-20" />
            <p class="text-sm tracking-wide font-semibold">(11) 96629-4417</p>
          </a>
        </div>
        <div class="text-sm tracking-wide font-medium">Compra 100% segura</div>
        <div class="flex items-center space-x-4">
          <ng-container *ngIf="!profile?.id">
            <div>
              <a [routerLink]="['/b']" class="text-sm leading-3"><strong>Entre</strong> ou <strong>Cadastre-se</strong></a>
            </div>
          </ng-container>
          <ng-container *ngIf="profile?.id">
            <div class="flex justify-center items-center space-x-1 group">
              <p [routerLink]="['/a']" class="text-sm inline-block align-middle">Olá, <strong>{{profile.name}} </strong></p>

              <div (click)="op.toggle($event)" class="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="w-4 h-4 stroke-amber-400">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              <p-overlayPanel #op [style]="{width: '200px'}">
                <div class="flex flex-col space-y-2">
                  <a [routerLink]="['/a/order']" class="text-pink-800 text-sm hover:font-semibold">Minhas Compras</a>
                  <a [routerLink]="['/a/wishlist']" class="text-pink-800 text-sm hover:font-semibold">Lista de Desejos</a>
                  <a [routerLink]="['/a']" class="text-pink-800 text-sm hover:font-semibold">Minha Conta</a>
                  <hr />
                  <a (click)="collectiveCustomerUserServiceLogout();" class="text-pink-800 text-sm hover:font-semibold cursor-pointer">Sair</a>
                </div>
              </p-overlayPanel>
            </div>
          </ng-container>

          <ng-container *ngIf="cart?.client_marketplace_cart_uid">
            <ng-container *ngIf="cart?.counter_item > 0">
              <a [routerLink]="['/p/cart']" [queryParams]="{uid: cart.client_marketplace_cart_uid}" class="relative inline-flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 stroke-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <div class="absolute -top-2 left-6 inline-flex h-4 w-4 items-center justify-center rounded-full bg-pink-800 p-2.5 text-xs font-bold text-white">{{cart.counter_item}}</div>
              </a>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <ng-container *ngIf="cart?.delivery_info.delivery_free == 'no' && cart?.delivery_info.diff_amount_delivery_free > 0">
      <ng-container *ngIf="cart?.counter_item > 0">
        <div class="flex justify-end px-6 pt-2">
          <span [routerLink]="['/p/cart']" [queryParams]="{uid: cart.client_marketplace_cart_uid}" class="inline-flex items-center gap-1 rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold text-blue-800 cursor-pointer hover:bg-blue-100"> Vamos de Frete Grátis? </span>
        </div>
      </ng-container>
    </ng-container>
  </section>

  <!-- Middle Section -->
  <section class="mx-auto max-w-7xl items-center">
    <div class="px-4 py-8 sm:px-6 lg:px-8 sm:flex sm:space-x-4">
      <div class="block pb-4 sm:pb-0 sm:flex-none">
        <a [routerLink]="['/']" title="{{marketplace?.name}}">
          <div class="overflow-hidden cursor-pointer">
            <img class="w-24 sm:w-48 hover:opacity-75 mx-auto" src="/assets/themes/{{environment.marketplace.domainObject.sld}}/images/logo.png" alt="Logo {{marketplace?.name}}" />
          </div>
        </a>
      </div>
      <!-- 
      // # /*
      // # |--------------------------------------------------------------------------
      // # | Form: Search
      // # |--------------------------------------------------------------------------
      // # |
      // # */
      -->
      <div class="block sm:flex-auto">
        <div class="mx-0">
          <form method="POST" (ngSubmit)="clientMarketplaceCoreProductServiceRedirectSearch();">
            <label class="mb-2 text-sm font-medium text-gray-400">
              <!-- <a [routerLink]="['/s']" class="text-pink-700 truncate"> Busca </a> -->
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg class="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                </svg>
              </div>
              <input type="search" [(ngModel)]="search.query" #search.query="ngModel" (keyup)="clientMarketplaceCoreProductServiceIndex()" class="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" placeholder="Produtos, categorias, dicas..." required />
              <div class="absolute right-2.5 bottom-2.5 hidden sm:flex sm:flex-1">
                <ng-container *ngIf="search.query && search.query != ''">
                  <button type="button" (click)="clientMarketplaceCoreProductServiceClear();" class="text-gray-700 right-12 bottom-2.5 font-medium text-sm px-1 py-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                      <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                    </svg>
                  </button>
                </ng-container>
                <button type="submit" class="text-white bottom-2.5 bg-pink-800 hover:bg-pink-900 focus:ring-4 focus:outline-none focus:ring-pink-300 font-medium rounded-lg text-sm px-4 py-2">Buscar</button>
              </div>
            </div>
            <ng-container *ngIf="searchResults?.facetDistribution?.categories">
              <div class="flex flex-1 space-x-1 pt-2 align-middle items-center text-sm text-gray-500">
                <span class="hidden sm:block">Mais produtos:</span>
                <ng-container *ngFor="let category of searchResults?.facetDistribution?.categories; let index = index">
                  <ng-container *ngIf="index < 5">
                    <span class="inline-flex items-center rounded-full bg-pink-50 px-2 py-1 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-600/10 truncate">
                      <ng-container *ngIf="search.query !==defined && search.query != ''">
                        <a [routerLink]="['/s/query/'+search.query]" [queryParams]="{'category': category.index}"> {{category.index}} </a>
                      </ng-container>
                      <ng-container *ngIf="search.query ===defined || search.query == ''">
                        <a [routerLink]="['/s']" [queryParams]="{'category': category.index}"> {{category.index}} </a>
                      </ng-container>
                    </span>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="!actualUrl.match('/s(.*)')">
              <ng-container *ngIf="searchResults?.data && search.query && search.query != ''">
                <ul class="absolute bg-white border border-gray-200 w-72 sm:w-96 mt-2 rounded-md shadow-md">
                  <ng-container *ngFor="let result of searchResults?.data; let index = index;">
                    <ng-container *ngIf="index < 4">
                      <li class="pl-8 pr-2 py-1 border-b-2 border-gray-100 relative cursor-pointer hover:bg-yellow-50 hover:text-gray-900">
                        <div class="flex items-center">
                          <div class="flex-none w-14">
                            <a [href]="result.url" class="cursor-pointer">
                              <img src="{{result.image_thumb}}" alt="{{result.name}}" class="w-14" />
                            </a>
                          </div>
                          <div class="ml-2" role="button">
                            <a [href]="result.url" class="cursor-pointer space-y-2">
                              <span class="leading-3" [innerHTML]="result._formatted.name | html"></span>
                              <span class="hidden sm:block text-gray-400 leading-3 text-xs" [innerHTML]="result._formatted.body_description_start | slice:0:128 | html"> ...</span>
                            </a>
                          </div>
                        </div>
                      </li>
                    </ng-container>
                  </ng-container>
                </ul>
              </ng-container>
            </ng-container>
          </form>
        </div>
      </div>
    </div>
  </section>

  <!-- Bottom Section -->
  <section>
    <div id="category_bar" class="sm:bg-pink-800 sm:py-1 sm:mb-4">
      <div class="flex overflow-auto items-center no-scrollbar px-4 sm:hidden">
        <ng-container *ngFor="let category of categories">
          <div class="bg-pink-800 rounded-full shrink-0 m-1">
            <p class="text-center text-white p-3 text-xs truncate sm:text-sm hover:font-bold cursor-pointer" (click)="getChildren(category.children, category)">{{category.name}}</p>
          </div>
        </ng-container>
        <a [routerLink]="['/subscription']" class="bg-pink-800 rounded-full shrink-0 m-1">
          <p class="text-center text-white p-3 text-xs sm:text-sm sm:font-semibold hover:font-bold sm:uppercase cursor-pointer">Clube Gê</p>
        </a>
        <a [routerLink]="['/salesman']" class="bg-pink-800 rounded-full shrink-0 m-1">
          <p class="text-center text-white p-3 text-xs sm:text-sm sm:font-semibold hover:font-bold sm:uppercase cursor-pointer">Marcas</p>
        </a>
        <a [routerLink]="['/s/sale/promo']" class="bg-pink-800 rounded-full shrink-0 m-1">
          <p class="text-center text-white p-3 text-xs sm:text-sm sm:font-semibold hover:font-bold sm:uppercase cursor-pointer">Promoções</p>
        </a>
      </div>

      <div class="hidden sm:block sm:px-8 sm:pb-2 md:pb-0 md:px-0">
        <div class="flex items-center justify-center space-x-8 sm:flex-wrap">
          <ul>
            <li class="group dropdown cursor-pointer">
              <div class="flex items-center space-x-1 p-3 group-hover:font-bold group-hover:bg-white group-hover:rounded-t-lg">
                <p class="text-center text-white text-sm tracking-wide uppercase font-semibold truncate group-hover:text-pink-800">
                  <a [routerLink]="['/s/query/Limpeza']" queryParamsHandling="merge"> Itens de Limpeza </a>
                </p>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="w-4 h-4 stroke-white">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              <div class="group-hover:block group-hover:ease-in-out group-hover:duration-500 dropdown-menu absolute hidden h-auto">
                <ul class="top-0 w-fit bg-white shadow px-8 py-7 grid grid-cols-2 grid-rows-5">
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Detergente'}" queryParamsHandling="merge" class="text-sm text-gray-800 truncate hover:font-semibold">Detergente</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Lenço Seco Eletrostático'}" class="text-sm text-gray-800 truncate hover:font-semibold">Lenço Seco Eletrostático!</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Lenço Umedecido'}" class="text-sm text-gray-800 truncate hover:font-semibold">Lenço Umedecido</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'MOP'}" class="text-sm text-gray-800 truncate hover:font-semibold">MOP</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Tira Mofo'}" class="text-sm text-gray-800 truncate hover:font-semibold">Tira Mofo</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Limpador'}" class="text-sm text-gray-800 truncate hover:font-semibold">Limpador</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Sabão em Pasta'}" class="text-sm text-gray-800 truncate hover:font-semibold">Sabão em pasta</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Tira Limo'}" class="text-sm text-gray-800 truncate hover:font-semibold">Tira Limo</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Lava Louças'}" class="text-sm text-gray-800 truncate hover:font-semibold">Lava Louças</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Desinfetante'}" class="text-sm text-gray-800 truncate hover:font-semibold">Desinfetante</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Limpeza'}" class="text-sm text-gray-800 truncate hover:font-semibold">Limpeza</a></li>
                </ul>
              </div>
            </li>
          </ul>

          <ul>
            <li class="group dropdown cursor-pointer">
              <div class="flex items-center space-x-1 p-3 group-hover:font-bold group-hover:bg-white group-hover:rounded-t-lg">
                <p class="text-center text-white text-sm tracking-wide uppercase font-semibold truncate group-hover:text-pink-800">
                  <a [routerLink]="['/s/query/KIT']" queryParamsHandling="merge"> KITS </a>
                </p>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="w-4 h-4 stroke-white">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              <div class="group-hover:block group-hover:ease-in-out group-hover:duration-500 absolute hidden h-auto">
                <ul class="top-0 w-fit bg-white shadow px-8 py-7 grid md:grid-cols-2 gap-x-6 sm:grid-cols-1">
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'KIT - Cuidados com as Roupas'}" class="text-sm text-gray-800 truncate hover:font-semibold">KIT - Cuidados com as Roupas</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'KIT - Cuidados com a Casa'}" class="text-sm text-gray-800 truncate hover:font-semibold">KIT - Cuidados com a Casa</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Kit Misto'}" class="text-sm text-gray-800 truncate hover:font-semibold">Kit Misto</a></li>
                </ul>
              </div>
            </li>
          </ul>

          <ul>
            <li class="group dropdown cursor-pointer">
              <div class="flex items-center space-x-1 p-3 group-hover:font-bold group-hover:bg-white group-hover:rounded-t-lg">
                <p class="text-center text-white text-sm tracking-wide uppercase font-semibold truncate group-hover:text-pink-800">
                  <a [routerLink]="['/s/query/Lavanderia']" queryParamsHandling="merge"> Lavanderia </a>
                </p>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="w-4 h-4 stroke-white">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              <div class="group-hover:block group-hover:ease-in-out group-hover:duration-500 absolute hidden h-auto">
                <ul class="top-0 w-fit bg-white shadow px-8 py-7 grid grid-cols-2 gap-x-6">
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Tira Manchas'}" class="text-sm text-gray-800 truncate hover:font-semibold">Tira Manchas</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Lavanderia'}" class="text-sm text-gray-800 truncate hover:font-semibold">Lavanderia</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Lava Roupas'}" class="text-sm text-gray-800 truncate hover:font-semibold">Lava Roupas</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Amaciantes'}" class="text-sm text-gray-800 truncate hover:font-semibold">Amaciantes</a></li>
                  <li class="py-1"><a [routerLink]="['/s']" [queryParams]="{'category': 'Facilitadores'}" class="text-sm text-gray-800 truncate hover:font-semibold">Facilitadores</a></li>
                </ul>
              </div>
            </li>
          </ul>

          <a [routerLink]="['/subscription']" class="p-3">
            <p class="text-center text-white text-sm tracking-wide uppercase font-semibold truncate cursor-pointer hover:font-bold">Clube Gê</p>
          </a>
          <div>
            <p class="text-center text-white text-sm tracking-wide uppercase font-semibold truncate cursor-pointer hover:font-bold">
              <a [routerLink]="['/salesman']" class="p-3"> Marcas </a>
            </p>
          </div>
          <div>
            <p class="text-center text-white text-sm tracking-wide uppercase font-semibold truncate cursor-pointer hover:font-bold">
              <a [routerLink]="['/s/sale/yes']" class="p-3">Promoções</a>
            </p>
          </div>
          <div>
            <p class="text-center text-white text-sm tracking-wide uppercase font-semibold truncate cursor-pointer hover:font-bold">
              <a [routerLink]="['/blog']" class="p-3">Blog</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="showCategoryChildren">
      <!-- Mobile -->
      <div class="px-4 mt-2">
        <div class="flex items-center justify-between">
          <p class="text-sm font-bold text-pink-800">{{currentCategory.name}}</p>
          <button (click)="hideChildren()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 stroke-pink-800">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="mt-1 w-full p-2 rounded-lg flex overflow-auto items-center no-scrollbar space-x-2">
          <div *ngFor="let child of categoryChildren" class="bg-orange-50 p-2 rounded-lg">
            <a [routerLink]="['/s']" [queryParams]="{category: child.name}">
              <p class="text-center text-xs text-pink-800 truncate">{{child.name}}</p>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </section>

  <ng-container *ngIf="!actualUrl.match('/p/(.*)/id') && !actualUrl.match('/p/cart') && !actualUrl.match('/p/checkout') && !actualUrl.match('/a/(.*)') && !actualUrl.match('/b/(.*)')">
    <ng-container *ngIf="banners?.length > 0">
      <ng-container *ngFor="let banner of banners;">
        <ng-container *ngIf="banner.core_visual_banner_area == 'full_banner_top_foot'">
          <img loading="lazy" class="hidden sm:block" src="{{banner.url_image}}" alt="{{banner.name}}" />
          <img loading="lazy" class="sm:hidden mr-4 rounded-lg w-176 h-176 cursor-pointer" src="{{banner.url_image_mobile}}" alt="{{banner.name}}" />
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</header>
